import React, { useMemo } from "react";
import { sanitizeHtml } from "../../helpers/utils";
import "./SafeHtml.scss";

export default ({ html, className, style }) => {
  const cleanHtml = useMemo(() => sanitizeHtml(html), [html]);
  return (
    <div
      className={`${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
      aria-label="c-safe-html"
    />
  );
};
